import { render, staticRenderFns } from "./CreateContentBtns.vue?vue&type=template&id=2355563b&scoped=true"
import script from "./CreateContentBtns.vue?vue&type=script&lang=js"
export * from "./CreateContentBtns.vue?vue&type=script&lang=js"
import style0 from "./CreateContentBtns.vue?vue&type=style&index=0&id=2355563b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2355563b",
  null
  
)

export default component.exports